// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

.button_outlined-button_R8Fss {
    cursor: pointer;
    border-radius: calc(0.5rem / 2);
    font-weight: bold;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-left: .75rem;
    padding-right: .75rem;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
}

.button_icon_Zg8pD {
    height: 1.5rem;
}

[dir="ltr"] .button_icon_Zg8pD {
    margin-right: .5rem;
}

[dir="rtl"] .button_icon_Zg8pD {
    margin-left: .5rem;
}

.button_content_NmxUc {
    white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/components/button/button.css"],"names":[],"mappings":"AAAA;sDACsD;;AAEtD,+CAA+C;;AAE/C;IACI,eAAe;IACf,+BAA+B;IAC/B,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,qBAAqB;IACrB,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":["/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n.outlined-button {\n    cursor: pointer;\n    border-radius: calc(0.5rem / 2);\n    font-weight: bold;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    padding-left: .75rem;\n    padding-right: .75rem;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n}\n\n.icon {\n    height: 1.5rem;\n}\n\n[dir=\"ltr\"] .icon {\n    margin-right: .5rem;\n}\n\n[dir=\"rtl\"] .icon {\n    margin-left: .5rem;\n}\n\n.content {\n    white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"outlined-button": `button_outlined-button_R8Fss`,
	"outlinedButton": `button_outlined-button_R8Fss`,
	"icon": `button_icon_Zg8pD`,
	"content": `button_content_NmxUc`
};
export default ___CSS_LOADER_EXPORT___;
